import { z } from 'zod';
import { order } from '@schuettflix/schema-registry-ts';

export const ItemFulfillmentEventSchema = order.fulfillmentService.versions.v1.schemas.LINE_ITEM_FULFILLED;
export type ItemFulfillmentEventPayload = z.infer<typeof ItemFulfillmentEventSchema>;

export const LINE_ITEM_TYPE_SCHEMA = order.fulfillmentService.versions.v1.schemas.LINE_ITEM_TYPE_SCHEMA;
export type LINE_ITEM_TYPE = z.infer<typeof LINE_ITEM_TYPE_SCHEMA>;
export const KEY_VALUE_SCHEMA = order.fulfillmentService.versions.v1.schemas.KEY_VALUE_SCHEMA;

export const LINE_ITEM_CATEGORY_SCHEMA = order.fulfillmentService.versions.v1.schemas.LINE_ITEM_CATEGORY_SCHEMA;
export type LINE_ITEM_CATEGORY = z.infer<typeof LINE_ITEM_CATEGORY_SCHEMA>;

export const FINANCIAL_REFERENCE_SCHEMA = order.fulfillmentService.versions.v1.schemas.FINANCE_REFERENCE_SCHEMA;
export type FINANCIAL_REFERENCE = z.infer<typeof FINANCIAL_REFERENCE_SCHEMA>;

export const FINANCIAL_REFERENCE_ARRAY_SCHEMA = z.array(FINANCIAL_REFERENCE_SCHEMA);
export type FINANCIAL_REFERENCE_ARRAY = z.infer<typeof FINANCIAL_REFERENCE_ARRAY_SCHEMA>;

export const FINANCE_REFERENCE_TYPES_SCHEMA =
    order.fulfillmentService.versions.v1.schemas.FINANCE_REFERENCE_TYPES_SCHEMA;
export type FINANCE_REFERENCE_TYPES = z.infer<typeof FINANCE_REFERENCE_TYPES_SCHEMA>;
